/* eslint-disable react-hooks/exhaustive-deps */
'use client';

import InnerLayout from '~/components/InnerLayout';
import ElectionMenu from '~/components/ElectionMenu';
import SlagSettings from './SlagSettings/SlagSettings';
import RegionSettings from './RegionSettings/RegionSettings';
import { observer } from 'mobx-react';
import { FC } from 'react';
import { getStore } from '~/mobx/AppStore';

interface Props {
    isCompany: boolean;
}

const GeneralSettings: FC<Props> = (props) => {
    const renderMainContent = () => {
        return props.isCompany ? <SlagSettings /> : <RegionSettings />;
    };
    return <InnerLayout className="preview-page" leftPanel={<ElectionMenu />} content={renderMainContent()} />;
};

const GeneralSettingsWithStore = () => {
    const { electionMenuStore } = getStore();
    const isCompany = electionMenuStore.getIsCompanyLevel();

    return <GeneralSettings isCompany={isCompany} />;
};

export default observer(GeneralSettingsWithStore);
